import React from 'react';
import { Link } from 'react-router-dom';
import styles from './Footer.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faFacebook,
  faTwitter,
  faInstagram,
  faLinkedin
} from '@fortawesome/free-brands-svg-icons';
import logoWhite from '../../assets/logo/default-monochrome-white.svg'; // Import white logo


const Footer = () => {
  return (
    <footer className={styles.footer}>
      <div className={styles.footerContainer}>
        <div className={styles.footerAbout}>
          <img src={logoWhite} alt="SolveDot Labs Logo" style={{ width: '240px', height: 'auto' }} />
          <p>Delivering guaranteed, high-quality software solutions with almost zero downtime. Your success is our mission.</p>

          {/* Social Links Section */}
          <div className={styles.socialLinks}>
            <a href="https://www.facebook.com/profile.php?id=61583182950566&sk=about_details" aria-label="Facebook"><FontAwesomeIcon icon={faFacebook} /></a>
            <a href="https://x.com/solvedotlabs" aria-label="Twitter"><FontAwesomeIcon icon={faTwitter} /></a>
            <a href="https://www.instagram.com/solvedotlabs/" aria-label="Instagram"><FontAwesomeIcon icon={faInstagram} /></a>
            <a href="https://www.linkedin.com/company/solvedotlabs/" aria-label="LinkedIn"><FontAwesomeIcon icon={faLinkedin} /></a>
          </div>
        </div>

        <div className={styles.footerLinks}>
          <h4>Quick Links</h4>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/services">Services</Link></li>
            <li><Link to="/case-studies">Case Studies</Link></li>
            <li><Link to="/about">About Us</Link></li>
            <li><Link to="/contact">Contact</Link></li>
            <li><Link to="/career">Career</Link></li>
          </ul>
        </div>

        {/* NEW Contact Info Section */}
        <div className={styles.footerContact}>
          <h4>Get in Touch</h4>
          <address>
            Habitech Qube Crystal Mall,<br />
            Knowledge Park 3,<br />
            Greater Noida, U.P.<br />
            India
          </address>
          <a href="tel:+917838443394" className={styles.contactLink}>+91 7838443394</a>
        </div>
      </div>
      <div className={styles.footerCopyright}>
        <p>&copy; {new Date().getFullYear()} SolveDot Labs Pvt. Ltd. All Rights Reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;